import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: window.appConfig.reverbAppKey,
    wsHost: window.appConfig.wsHost,
    wsPort: window.appConfig.wsPort,
    wssPort: window.appConfig.wssPort,
    forceTLS: window.appConfig.wssForceTLS,
    enabledTransports: ['ws', 'wss'],
});

export default {
    privateListen: function (channelName, channelId, callBack, eventName = channelName) {
        window.Echo.private(channelName + '.' + channelId)
            .listen('.' + eventName, callBack);
    },

    privateListenOff: function (channelName, channelId, eventName = channelName) {
        window.Echo.private(channelName + '.' + channelId)
            .stopListening('.' + eventName);
    },

    onConnected: function (callback) {
        const connection = window.Echo?.connector?.pusher?.connection;
        if (!connection?.bind || !connection?.unbind) {
            return () => {};
        }
        connection.bind('connected', callback);

        return () => connection.unbind('connected', callback);
    },
}
